import React, { useEffect } from 'react';
import { track } from '@lf/analytics-events';
import { LoadingButton } from '@lf/ui-primitives';
import { useStudentCheckout } from '../lib/subscription/checkout';

function StudentSubscribePrompt({ subscriptionAction, isLinked }) {
    const { startCheckout, isLoading, error } = useStudentCheckout(
        'student_subscribe_prompt');
    const action = subscriptionAction?.action;

    const isEligible =
        !isLinked &&
        (action === 'create_new' || action === 'create_new_has_canceled');

    useEffect(() => {
        if (isEligible) {
            track('student_subscribe_view', { action });
        }
    }, [isEligible, action]);

    if (!isEligible) return null;

    // Learnforest owns the trial and it is already spent by the time this
    // paywall shows, so the CTA always charges immediately — never "start a
    // trial". create_new = trial just ended; create_new_has_canceled = a
    // previous subscription was canceled.
    const isCreateNew = action === 'create_new';
    const heading = isCreateNew ? 'Your free trial has ended' : 'Your subscription has ended';
    const subheading = isCreateNew
        ? 'Subscribe to keep learning with Learnforest.'
        : 'Resubscribe to keep learning with Learnforest.';
    const ctaLabel = 'Subscribe';

    return (
        <div className="border border-gray-200 rounded-2xl p-6 mb-6 max-w-sm">
            <div className="text-lg font-semibold mb-1">{heading}</div>
            <div className="text-sm text-gray-500 mb-4">{subheading}</div>
            <div className="bg-white border border-gray-200 rounded-xl p-4 mb-4">
                <div className="font-bold text-darkrock mb-1">Student Plan</div>
                <div className="text-2xl font-bold text-darkrock mb-2">$3.99/mo</div>
                <ul className="space-y-1 text-sm text-darkrock/70 mb-4">
                    <li>✓ AI study plans</li>
                    <li>✓ Curated videos, no ads</li>
                    <li>✓ Progress tracking</li>
                </ul>
                <LoadingButton
                    text={ctaLabel}
                    isLoading={isLoading}
                    aria-busy={isLoading}
                    onClick={startCheckout}
                    className="bg-primary text-white w-full py-3 rounded-xl font-semibold"
                />
                {error && (
                    <div role="alert" className="text-red-500 text-sm mt-2">
                        {error}
                    </div>
                )}
            </div>
            <p className="text-sm text-gray-500">
                Have a parent?{' '}
                <a
                    href="/settings"
                    className="text-primary underline"
                >
                    Link your account
                </a>{' '}
                to use their plan instead.
            </p>
        </div>
    );
}

export default StudentSubscribePrompt;
